import { Input } from '@ahafood/ui/components/input';
import React, {
  forwardRef,
  type InputHTMLAttributes,
  useEffect,
  useState,
} from 'react';

type DebouncedInputProps = {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'>;

export const DebouncedInput = forwardRef<HTMLInputElement, DebouncedInputProps>(
  ({ value: initialValue, onChange, debounce = 500, ...props }, ref) => {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
      setValue(initialValue);
    }, [initialValue]);

    useEffect(() => {
      const timeout = setTimeout(() => {
        onChange(value);
      }, debounce);

      return () => {
        clearTimeout(timeout);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return (
      <Input
        ref={ref}
        {...props}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
      />
    );
  }
);
DebouncedInput.displayName = 'DebouncedInput';
